<div class="offcanvas-header header offcanvas-scrollable-content">
  <h5 class="offcanvas-title" id="offcanvas-basic-title">Documentation</h5>
  <i
    class="feather icon-x btn btn-icon btn-light close-btn"
    (click)="closeDocumentation()"
  ></i>
</div>
<div class="offcanvas-body">
  <h3 class="mb-3">
    {{ activeSection.title | titlecase }}
  </h3>
  <!-- inner html the active section content -->
  <div *ngIf="activeSection.content; else noData">
    <div [innerHTML]="activeSection.content"></div>
  </div>
  <ng-template #noData>
    <div class="no-data">
      <h4>No data found</h4>
    </div>

    <div class="offcanvas-footer footer">
      <i
        class="feather icon-arrow-right icon-lg btn-danger close-btn"
        (click)="closeDocumentation()"
      ></i>
    </div>
  </ng-template>
</div>
